import React from 'react';

export interface FeeUnavailableAlertProps {
  onRetry: () => void;
}

/** Shown when the server fee schedule could not be loaded. */
const FeeUnavailableAlert = ({ onRetry }: FeeUnavailableAlertProps) => (
  <div
    className="mt-4 mb-2 rounded-xl border border-red-200 bg-red-50 p-3 flex items-start justify-between gap-3"
    role="alert"
  >
    <p className="m-0 text-xs text-red-700 leading-relaxed">
      We could not load your fee. Please check your connection and try again.
    </p>
    <button
      type="button"
      className="shrink-0 text-xs font-semibold text-red-800 underline"
      onClick={onRetry}
    >
      Try again
    </button>
  </div>
);

export default FeeUnavailableAlert;
